import {CancelablePromise} from '../api';

export function withAbortSignal<T>(fn: () => CancelablePromise<T>, signal?: AbortSignal) {
    const promise = fn();
    signal?.addEventListener('abort', () => {
        promise.cancel();
    });
    return promise;
}